import { useEffect, useState } from "react";
import "../style/navbar.css";
import logo from "../image/ninjaimg.jpg";
import { db, auth } from "../context/Firebase";
import { useUser } from "../context/adminContext";
import { NavLink } from "react-router-dom";
import { signOut } from "firebase/auth";

export default function Navbar() {
  const { user, stores, setUser } = useUser();
  const [open, setOpen] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    if (isLoggingOut) return; // Prevent multiple clicks
    
    try {
      setIsLoggingOut(true);
      await signOut(auth);
      // Clear any local storage if needed
      localStorage.removeItem('adminUser');
      localStorage.removeItem('userToken');
      sessionStorage.removeItem('pendingApproval');
      // Navigate to login page
      window.location.href = "/";
    } catch (error) {
      console.error("Logout error:", error);
      setIsLoggingOut(false); // Reset on error
    }
  };

  useEffect(() => {
    if (!open) return; // Don't add listener if dropdown is closed
    
    const handleClickOutside = (event) => {
      if (!event.target.closest('.store-switch-wrapper')) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  // Don't render navbar if user is not loaded yet
  if (!user) {
    return null;
  }
  return (
    <nav className="admin-navbar">
      <div className="admin-navbar-left">
        <div className="admin-navbar-brand">
          <img className="logo" src={logo} alt="Ninja Deliveries Logo" />
          <span className="brand-name">Ninja Deliveries</span>
        </div>
        <div className="store-switch-wrapper">
  <button
  className="store-name"
  onClick={() => setOpen(!open)}
>
  🏬 {user && stores ? (stores.find(s => s.id === user.storeId)?.name || "No Store") : "Loading..."} 
  <span style={{ 
    fontSize: '0.7rem', 
    marginLeft: '2px',
    transition: 'transform 0.2s ease',
    transform: open ? 'rotate(180deg)' : 'rotate(0deg)'
  }}>
    ▼
  </span>
</button>
  {open && user && stores && (
    <div className="store-dropdown">
      {stores
        .filter((s) => s.id !== user.storeId)
        .map((store) => (
          <div
            key={store.id}
            className="store-option"
            onClick={() => {
              if (!user) return;
              setUser((prev) => prev ? ({
                ...prev,
                storeId: store.id,
              }) : null);
              setOpen(false);
            }}
          >
            {store.name}
          </div>
        ))}
    </div>
  )}
</div>
      </div>

      {/* Mobile Hamburger Menu Toggle */}
      <button 
        className="mobile-menu-toggle"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        aria-label="Toggle menu"
      >
        {mobileMenuOpen ? (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        )}
      </button>

      <ul className={`admin-navbar-nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
        <li>
          <NavLink to="/home" activeclassname="active" onClick={() => setMobileMenuOpen(false)}>
            Home
          </NavLink>
        </li>
        <li>
          <NavLink to="/productslist" activeclassname="active" onClick={() => setMobileMenuOpen(false)}>
            Products
          </NavLink>
        </li>
        <li>
          <NavLink to="/riderlist" activeclassname="active" onClick={() => setMobileMenuOpen(false)}>
            Riders
          </NavLink>
        </li>
        <li>
          <NavLink to="/scanorder" activeclassname="active" onClick={() => setMobileMenuOpen(false)}>
            Scan Order
          </NavLink>
        </li>
        <li>
          <NavLink to="/report" activeclassname="active" onClick={() => setMobileMenuOpen(false)}>
            Reports
          </NavLink>
        </li>
        {(user?.permissions?.includes("page:users") || user?.roleKey === "all_access_admin") && (
          <li>
            <NavLink to="/admin" className={({ isActive }) => isActive ? "active" : ""} onClick={() => setMobileMenuOpen(false)}>
              Admin Panel
            </NavLink>
          </li>
        )}
        <li className="logout-wrapper-compact">
          <button
            className="logout-compact-btn"
            onClick={handleLogout}
            disabled={isLoggingOut}
            title="Logout"
          >
            <div className="logout-sign-compact">
              <svg viewBox="0 0 512 512">
                <path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9z" />
              </svg>
            </div>
            <span className="logout-text-compact">
              {isLoggingOut ? "Wait..." : "Logout"}
            </span>
          </button>
        </li>
      </ul>
    </nav>
  );
}
